export const API_ENDPOINT = 'https://help.sorare.com/api/v2/help_center';
